import React from "react";
import DatePicker from "react-datepicker";
import {IEventCalendarState, IEventCalendarProps} from "../../../types";
import {getDateFromString} from "../../../utils/dateUtils";

type Props = IEventCalendarProps;
type State = IEventCalendarState;

class EventCalendarFormControl extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      availableDates: null,
      selectedDate: null,
      selectedDay: null,
    };
  }

  render() {
    return (
      <React.Fragment>
        <DatePicker
          selected={this.state.selectedDay}
          onChange={e => this.onDateChange(e)}
          onMonthChange={e => this.onMonthChange(e)}
          minDate={this.props.minDate ? getDateFromString(this.props.minDate) : null}
          maxDate={this.props.maxDate ? getDateFromString(this.props.maxDate) : null}
          renderDayContents={this.renderDayContents}
          inline
          disabledKeyboardNavigation
        />
      </React.Fragment>
    );
  }

  private renderDayContents = (day: number, date: Date) => {
    if (!this.props.eventDates) {
      return <span>{day}</span>;
    }

    let recommendationNumber;

    return (
      <React.Fragment>
        <span>{day}</span>
          {this.props.eventDates
            .map(
              (el: any) => {
                if(el[0] === `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`) {
                  recommendationNumber = el[1];
                }
                return el[0];
              }
            ).includes(
              `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            ) ? (<div className="calendar-label"/>) : null}
      </React.Fragment>
    )
  };

  private onMonthChange = (e: any) => {
    if (e) {
      const eventData = {
        target: {
          value: {
            name: "month",
            value: e
          }
        }
      };
      this.props.onChange(eventData);
    }
  };

  private onDateChange = (e: any) => {
    if (e) {
      const eventData = {
        target: {
          value: {
            name: "date",
            value: e
          }
        }
      };
      this.setState({ selectedDay: e });
      this.props.onChange(eventData);
    }
  };
}

export default EventCalendarFormControl;
